import type { PriceDetails } from '../../global-types/Content';
import Paragraph from '../paragraph/Paragraph';

function PriceSummaryCard({ details }: { details: PriceDetails }) {
  return (
    <div className="if card elevated mb-8 size-w-100p">
      <div className="if card-content flex-column gap-4">
        <div className="if flex justify-content-space-between">
          <Paragraph text={details.productName} size="medium" />
          <Paragraph text={details.productPrice} size="medium" />
        </div>
        <div className="if flex justify-content-space-between">
          <Paragraph text={details.discountAmountText!} size="small" color="color-green-400" />
          <Paragraph text={details.discountAmount!} size="small" color="color-green-400" />
        </div>
        <hr className="if border-top-solid color-beige-400 my-8" />
        <div className="if flex justify-content-space-between">
          <Paragraph text={details.customerPriceText!} size="medium" />
          <span className={`if typography ui medium weight-bold`}>{details.customerPrice}</span>
        </div>
        <span className={`if typography ui small align-self-end`}>{details.yearlyCustomerPrice}</span>
      </div>
    </div>
  );
}

export default PriceSummaryCard;
